// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"7d3befda","605":"c9edb8ca","809":"62452d41","981":"c1608f4d"}[chunkId] + ".chunk.js";
};